export default function PremierInnFormCheckerFactory(
    l10nService,
    userService,
    authService,
    HOTELS_SUPPLIERS
) {
    'ngInject';

            const regionalSettings = userService.getRegionalSettings();
            const isPrimierInnEnabled = authService.isSupplierEnabled(HOTELS_SUPPLIERS.PREMIER_INN);

            if (!isPrimierInnEnabled) {
                return [];
            }

            return [
                {
                    propertyName: 'options.roomsListSelected.value',
                    needToShowMessage(property) {
                        if (!property) {
                            return true;
                        }
                        return +property < 5;
                    },
                    message: l10nService.localize('For Premier Inn bookings exceeding 4 rooms please contact your reservations team'),
                },
                {
                    propertyName: 'options.occupantsSelected.value',
                    needToShowMessage(property) {
                        if (!property) {
                            return true;
                        }
                        return +property < 3;
                    },
                    message: l10nService.localize('For Premier Inn bookings exceeding 2 Adults please contact your reservations team'),
                },
                {
                    propertyName: 'params',
                    needToShowMessage(params) {
                        if (!params.checkInDate || !params.checkOutDate) {
                            return true;
                        }
                        return moment(params.checkOutDate, regionalSettings.dateFormat).diff(
                                moment(params.checkInDate, regionalSettings.dateFormat), 'days') < 10;
                    },
                    message: l10nService.localize('For Premier Inn bookings exceeding 9 nights please contact your reservations team'),
                },
            ];
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/services/premierInnFormChecker.js